import { render } from "./ClockIcon.vue?vue&type=template&id=054fefa5"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ClockIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "054fefa5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('054fefa5', __exports__)) {
    api.reload('054fefa5', __exports__)
  }
  
  module.hot.accept("./ClockIcon.vue?vue&type=template&id=054fefa5", () => {
    api.rerender('054fefa5', render)
  })

}


export default __exports__